import { t } from 'i18next';
import {
  NODE_CATEGORIES,
  NODE_TYPES,
} from '../../../../../constants/workflow.constant';

export const validateWorkflowStructure = (workflowData) => {
  const { nodes, edges } = workflowData || {};

  if (!nodes || nodes.length <= 1) {
    return {
      message: t('workflowValidation.submissionAndReviewNodesRequired'),
    };
  }

  if (!edges || edges.length === 0) {
    return { message: t('workflowValidation.connectNodesRequired') };
  }

  const endNode = nodes.find((node) => node.category === NODE_CATEGORIES.END);
  if (!endNode) {
    return { message: t('workflowValidation.endNodeRequired') };
  }

  const formStageNodes = nodes.filter(
    (node) => node.type === NODE_TYPES.FORM_STAGE
  );
  if (formStageNodes.length === 0) {
    return {
      message: t('workflowValidation.formStageNodeRequired'),
    };
  }

  const formStageIds = formStageNodes.map((node) => node.id);
  const formStageEdges = edges.filter((edge) =>
    formStageIds.includes(edge.source)
  );
  if (formStageEdges.length === 0) {
    return { message: t('workflowValidation.connectFormStageNodesRequired') };
  }

  const selfLoopEdges = edges.filter((edge) => edge.source === edge.target);
  if (selfLoopEdges.length > 0) {
    const selfLoopNodeIds = selfLoopEdges.map((edge) => edge.source);
    return {
      message: t('workflowValidation.selfLoopNodes', {
        nodes: selfLoopNodeIds.join(', '),
      }),
    };
  }

  return null;
};

export const validateNodeConnectivity = (nodes, edges) => {
  const invalidNodes = nodes.filter((node) => {
    if (node.category === NODE_CATEGORIES.END) {
      const hasIncomingEdge = edges.some((edge) => edge.target === node.id);
      return !hasIncomingEdge;
    }

    if (node.category === NODE_CATEGORIES.START) {
      const hasOutgoingEdge = edges.some((edge) => edge.source === node.id);
      const hasIncomingEdge = edges.some((edge) => edge.target === node.id);
      return !hasOutgoingEdge || hasIncomingEdge;
    }

    const hasIncomingEdge = edges.some((edge) => edge.target === node.id);
    const hasOutgoingEdge = edges.some((edge) => edge.source === node.id);
    return !(hasIncomingEdge && hasOutgoingEdge);
  });

  if (invalidNodes.length > 0) {
    return { message: t('workflowValidation.nodesProperlyConnected') };
  }

  return null;
};

export const validateStartNodeConnections = (nodes, edges) => {
  const startNodes = nodes.filter(
    (node) => node.category === NODE_CATEGORIES.START
  );

  for (const startNode of startNodes) {
    const outgoingEdges = edges.filter((edge) => edge.source === startNode.id);
    if (outgoingEdges.length !== 1) {
      return { message: t('workflowValidation.startNodeSingleOutgoing') };
    }
  }

  return null;
};
